import totoService from '../services/toto.service';

const handlers = {
  toto: {
    session: {
      set: 'toto_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.toto = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.toto = (state => state.toto);
}

const initActions = function(actions) {
  actions[handlers.toto.session.set] = ({ commit }, session) => commit(handlers.toto.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.toto.session.set] = (state, session) => state.toto.session = session;
}

const initAppState = function(appState, store) {
  appState.toto = {
    session: {
      get: () => store.getters.toto.session,
      open: async () => {
        let session = await totoService.openSession();
        store.dispatch(handlers.toto.session.set, session);
      },
      close: async () => {
        if (store.getters.toto.session) {
          await totoService.closeSession();
        }
        store.dispatch(handlers.toto.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/toto.js